import { Trans } from 'react-i18next'
import theme from 'theme'
import Box from 'UIKit/Box/Box'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import Column from '../../Column'
import { RowBetween, RowMiddle } from '../../Row'
import useAvailableTokens from './useAvailableTokens'

const CoinList = () => {
  const tokens = useAvailableTokens()

  return (
    <RowBetween>
      <Column maxWidth={['', , , , , '70%']}>
        <Text
          mt={['12px', '20px']}
          mb={theme.spacing.fix_150}
          fontWeight={400}
          fontSize="12px"
          lineHeight="20px"
          letterSpacing="-0.02em"
          color="textSubtle"
        >
          <Trans>Payment methods</Trans>
        </Text>
        <RowMiddle flexWrap="wrap" gap={theme.spacing.fix_100}>
          {tokens?.map((token) => (
            <Box data-tooltip-id="common-tip-top" data-tooltip-content={token.code} style={{ cursor: 'pointer' }}>
              <Image key={token.code} src={token.logo} width={24} height={24} />
            </Box>
          ))}
        </RowMiddle>
      </Column>
    </RowBetween>
  )
}

export default CoinList
